import React, {useEffect, useState} from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Checkbox from "./Checkbox";
import {distortions, distortionDescriptions} from "../assets/constants";
import {capitalizeWords} from "../assets/utils";
import PrevAndNextComponent from "../components/PrevAndNextComponent";
import HeaderWithSubHeader from "../components/HeaderWithSubHeader";
import TextQuestionWithIcon from "../components/TextQuestionWithIcon";
import {ArrowCircleRightOutlined} from "@mui/icons-material";
import {Button} from "@mui/material";
import ArrowCircleDownOutlinedIcon from '@mui/icons-material/ArrowCircleDownOutlined';
import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined';

const ThinkingTraps = ({step, steps, handleNext, handleBack, activeStep, handleSetStepSummary}) => {
    const [canMoveOn, setCanMoveOn] = useState(true);
    const [thinkingTrap, setThinkingTrap] = useState([]);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        setThinkingTrap(distortions.map((distortion) => {
            return {
                isSelected: false,
                label: capitalizeWords(distortion),
                description: distortionDescriptions[distortion]
            };
        }));
    }, []);

    useEffect(() => {
        const selectedTitles = step.summary;
        if(!selectedTitles) {
            return;
        }
        const array = selectedTitles.split('; ');
        const newThinkingTrap = [...thinkingTrap].map((trap) => {
            if(array.includes(trap.label)) {
                trap.isSelected = true;
            }
            return trap;
        });
        setThinkingTrap(newThinkingTrap);
    }, [activeStep, step, thinkingTrap]);

    const toggleThinkingTrap = (trap) => {
        let index = thinkingTrap.findIndex(t => t.label === trap.label && t.description === trap.description);
        const newThinkingTrap = [...thinkingTrap];
        if (index !== -1) {
            newThinkingTrap[index] = {
                ...newThinkingTrap[index],
                isSelected: !newThinkingTrap[index].isSelected
            };
            setThinkingTrap(newThinkingTrap);
        }
    };

    const validate = () => {
        let selectedCount = 0;
        thinkingTrap.forEach((trap) => {
            if(trap.isSelected) {
                selectedCount++;
            }
        })
        return selectedCount>0 && selectedCount <4;
    }

    const handleLocalNext = () => {
        // validate at least one selection..
        if(!validate()) {
            setCanMoveOn(false);
            return;
        }
        setCanMoveOn(true);
        const selectedLabels = thinkingTrap.filter(trap => trap.isSelected).map(trap => trap.label).join("; ");
        handleSetStepSummary({...step, summary: selectedLabels});
        handleNext();
    };

    const toggleShowAll = () => {
        setShowAll(!showAll);
    }

    return (
        <div style={{display: "flex", justifyContent: "flex-start", flexDirection: "column", textAlign: "left", fontSize: "24px"}}>
            <HeaderWithSubHeader steps={steps} step={step}/>
            <br/>

            <div className="blue-box shadow-sm">
                <TextQuestionWithIcon text="What's a Thinking Trap?" icon={<InfoOutlinedIcon />} />
                <p style={{marginLeft: "5px", fontSize: "16px", marginTop: "10px"}}>Our negative thinking often falls into common patterns, called "thinking traps." We can learn to recognize when we're getting stuck in a thinking trap. This gives us more power over our negative thoughts.</p>
                <p style={{marginLeft: "5px", fontSize: "16px", marginTop: "10px"}}>Common thinking traps include: assuming what others think (“Mind reading”), thinking in extremes (“All-or-nothing thinking”), focusing on the worst-case scenario (“Catastrophizing”), focusing only on the bad (“Disqualifying the positive”), etc.</p>

            </div>
            <br/>
            <div style={{display: "flex", alignItems: "center", color: "#144b5e", marginLeft: "5px"}}><ArrowCircleRightOutlined /> <label style={{fontSize: "20px", fontWeight: "bold", marginLeft: "10px"}}> Select the Thinking Trap</label></div>
            <p style={{color: "gray", marginLeft: "10px", fontSize: "16px", fontWeight: "500"}}>Here are some thinking traps that might be related to your negative thought. Select the thinking trap that you most relate to.</p>
            <p className="fs-5-5" style={{color: "black", marginLeft: "10px", fontSize: "14px"}}><mark style={{backgroundColor: "#fff3e0", padding: "0.2em"}}><b>Note:</b> You may select more than one thinking traps (up to three)</mark></p>
            <div style={{marginLeft: "10px"}}>
                <Checkbox toggleThinkingTrap={toggleThinkingTrap} thinkingTrap={showAll ? thinkingTrap : thinkingTrap.slice(0, 4)}/>
                <br/>
                {showAll ?
                    <Button variant="outlined" style={{borderRadius: "100px"}} color="error" startIcon={<ArrowCircleUpOutlinedIcon />} onClick={toggleShowAll}>
                    Hide additional thinking traps
                    </Button>
                :
                    <Button variant="outlined" style={{borderRadius: "100px"}} color="primary" startIcon={<ArrowCircleDownOutlinedIcon/>} onClick={toggleShowAll}>
                        Show additional thinking traps
                    </Button>
                }
            </div>
            <br/>

            {!canMoveOn && (<>
                <p className="fs-5-5" style={{color: "black", marginLeft: "10px", fontSize: "14px"}}><mark style={{backgroundColor: "#FFB0B0", padding: "0.2em"}}><b>Note:</b> You may select more than one thinking traps (up to three)</mark></p>
                <br/>
            </>)}

            <PrevAndNextComponent steps={steps} activeStep={activeStep} handleBack={handleBack} handleLocalNext={handleLocalNext} />

        </div>
    );
};

export default ThinkingTraps;